<template>
  <Layout>
    <template slot="title">Página No Encontrada</template>

    <Error404 />
  </Layout>
</template>

<script>
import Layout from '@/layouts/MainLayout'
import Error404 from '@/components/Error404'

export default {
  components: { Layout, Error404 },
}
</script>
